var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1303 9.58955C4.47083 9.57633 4.81187 9.59168 5.14984 9.63543L7.74628 10.4414L7.90034 10.5207C8.5857 10.9019 9.04903 11.8173 9.04903 12.6012C9.01448 13.0877 8.8961 15.7476 8.92668 16.6068C8.8961 17.4661 9.01448 20.126 9.04903 20.6125C9.0496 21.3964 8.5857 22.3089 7.90034 22.6929C7.32289 22.9998 6.71077 23.2363 6.07706 23.3976C5.44335 23.5682 4.78796 23.6445 4.132 23.6241C3.34015 23.5901 2.46278 22.7683 2.16598 21.7867C1.9077 21.2084 1.42001 17.7482 1.51121 16.6068C1.42001 15.4655 1.90939 12.0053 2.16428 11.427C2.45881 10.4454 3.33732 9.62297 4.1303 9.58955Z",
    fill: "url(#paint0_linear_115_6829)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8678 9.58955C28.6596 9.62297 29.5393 10.4454 29.8338 11.427C30.0898 12.0053 30.5798 15.4655 30.4886 16.6063C30.5798 17.7476 30.0904 21.2078 29.8338 21.7861C29.5393 22.7677 28.6608 23.5901 27.8678 23.6236C27.2137 23.6449 26.56 23.5697 25.9278 23.4004L24.2269 22.7598L24.0989 22.6935C23.4135 22.3095 22.9502 21.397 22.9502 20.6131C22.9847 20.1265 23.1031 17.4667 23.0725 16.6074C23.1031 15.7482 22.9847 13.0883 22.9502 12.6017C22.9496 11.8173 23.4135 10.9025 24.0989 10.5207L24.2529 10.4414L26.8482 9.63543C27.1862 9.59168 27.5273 9.57633 27.8678 9.58955Z",
    fill: "url(#paint1_linear_115_6829)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7596 29.0842C21.9457 28.4391 24.5937 26.285 25.9281 23.4003L24.2272 22.7597C23.6844 23.889 22.8937 24.8813 21.9141 25.6625C20.9344 26.4438 19.7911 26.9938 18.5693 27.2717C18.3182 26.8608 17.9348 26.5475 17.4821 26.3834C17.0293 26.2192 16.5342 26.214 16.0781 26.3684C15.622 26.5229 15.232 26.828 14.9722 27.2334C14.7124 27.6389 14.5983 28.1207 14.6486 28.5997C14.6989 29.0786 14.9106 29.5262 15.249 29.8688C15.5873 30.2115 16.0321 30.4289 16.5104 30.4853C16.9886 30.5417 17.4719 30.4337 17.8806 30.1791C18.2894 29.9244 18.5993 29.5384 18.7596 29.0842ZM16 4.22269C19.9055 4.22269 23.2105 6.85254 24.2533 10.4413L26.8486 9.63533C25.4631 4.93977 21.1244 1.50391 16 1.50391C10.8757 1.50391 6.53699 4.93977 5.14984 9.63533L7.74628 10.4413C8.78961 6.85254 12.0946 4.22269 16 4.22269Z",
    fill: "url(#paint2_linear_115_6829)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_6829",
    x1: 1.5,
    y1: 16.6062,
    x2: 9.04903,
    y2: 16.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_6829",
    x1: 22.9502,
    y1: 16.606,
    x2: 30.4998,
    y2: 16.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_6829",
    x1: 1.5,
    y1: 16.0019,
    x2: 30.5001,
    y2: 16.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCall);
export default __webpack_public_path__ + "static/media/supportCall.c08d5575411a931e8ba179afa624ac27.svg";
export { ForwardRef as ReactComponent };